import StatusChip, { ChipType } from 'components/@extended/StatusChip';
import { useMemo } from 'react';
import { ClassifierData } from 'types/classifiers';
import { ExpenseStatusType } from 'types/expenses';
import { getClassifierText } from 'utils/getTranslations';

export interface ExpenseStatusLabelProps {
    statusCode: string;
    classifier: ClassifierData;
    isNonBillable: boolean;
}

export const ExpenseStatusLabel = ({
    statusCode,
    classifier,
    isNonBillable,
}: ExpenseStatusLabelProps): JSX.Element | null => {
    const label = useMemo(() => getClassifierText(classifier, statusCode), [statusCode, classifier]);

    const statusChipType = useMemo<ChipType>(() => {
        switch (statusCode) {
            case ExpenseStatusType.FINISHED:
            case ExpenseStatusType.PAID:
                return 'success';
            default:
                return undefined;
        }
    }, [statusCode]);

    if (isNonBillable) {
        return null;
    }

    return <StatusChip type={statusChipType} label={label} />;
};
